import { render, staticRenderFns } from "./permissionsProjects.vue?vue&type=template&id=42ac6bea&scoped=true&"
import script from "./permissionsProjects.vue?vue&type=script&lang=js&"
export * from "./permissionsProjects.vue?vue&type=script&lang=js&"
import style0 from "./permissionsProjects.vue?vue&type=style&index=0&id=42ac6bea&prod&lang=less&scoped=true&"
import style1 from "./permissionsProjects.vue?vue&type=style&index=1&id=42ac6bea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ac6bea",
  null
  
)

export default component.exports